/**
 * Simple token store for tRPC auth header. Updated on login/logout and app init.
 */
let accessToken: string | null = null;

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function getAccessToken(): string | null {
  return accessToken;
}
